import Axios from "../config/axiosInterceptor";
import {ContentApiRoutes} from "../../navigation/NavConstant";
export const DashboardServices = {
    // admin-aggregate-report
    getAdminAggregateReport : (data:any) =>  Axios.post(ContentApiRoutes.DASHBOARD_ADMIN_AGG_REPORT,data),
    
    // aggregate report
    getAggregateReport : (data:any) => Axios.post(ContentApiRoutes.DASHBOARD_AGG_REPORT,data)
    
};
